export class CreativeSaveFailed extends Error {
    constructor(message, originalError) {
        super(message || "Failed to save creative, please try again.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CreativeSaveFailed);
        }
        this.name = "CreativeSaveFailed";
        this.originalError = originalError;
    }
}
//# sourceMappingURL=errors.js.map